"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sourceFragment_1 = require("../fragments/sourceFragment");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [...sourceFragment_1.sourceFragmentDependencies, sourceFragment_1.sourceFragment];
const MUTATION = `
query getSources {
  source {
    ...sourceFragment
  }
}
`.trim();
const getSourcesImpl = (0, notifi_axios_utils_1.makeParameterLessRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'source');
exports.default = getSourcesImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0U291cmNlc0ltcGwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9saWIvcXVlcmllcy9nZXRTb3VyY2VzSW1wbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGdFQUdxQztBQUNyQywyRUFHNEM7QUFHNUMsTUFBTSxZQUFZLEdBQUcsQ0FBQyxHQUFHLDJDQUEwQixFQUFFLCtCQUFjLENBQUMsQ0FBQztBQUVyRSxNQUFNLFFBQVEsR0FBRzs7Ozs7O0NBTWhCLENBQUMsSUFBSSxFQUFFLENBQUM7QUFFVCxNQUFNLGNBQWMsR0FBRyxJQUFBLDZDQUF3QixFQUM3QyxJQUFBLHdDQUFtQixFQUFDLEdBQUcsWUFBWSxFQUFFLFFBQVEsQ0FBQyxFQUM5QyxRQUFRLENBQ1QsQ0FBQztBQUVGLGtCQUFlLGNBQWMsQ0FBQyJ9